<template>
    <div>
        <select class="mt-2 badge badge-secondary" v-model="selectedCategory" @change="categoryChanged">
            <option value="null">Välj kategori</option>
            <option v-for="category in categories" :value="category">{{ category.name }}</option>
        </select>

        <select class="mt-2 badge badge-secondary" v-if="selectedCategory !== 'null'" v-model="selectedSubcategory" @change="subcategoryChanged">
            <option value="null">Alla underkategorier</option>
            <option v-for="subcategory in selectedCategory.childrens" :value="subcategory">{{ subcategory.name }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        props: {
            routeStart: { required: true },
            routeCategory: { required: true },
            routeSubcategory: { required: true },
        },

        watch: {
            "$route": function (route) {
                if ([this.routeCategory, this.routeSubcategory].includes(this.$route?.name)) {
                    this.setCategoryBySlug();
                    this.$emit('updated');
                }

                if (route.name === this.routeStart) {
                    this.$emit('updated');
                    this.selectedSubcategory = 'null';
                    this.selectedCategory = 'null';
                }
            }
        },

        data () {
            return {
                selectedCategory: 'null',
                selectedSubcategory: 'null',
            }
        },

        mounted () {
            if ([this.routeCategory, this.routeSubcategory].includes(this.$route?.name)) {
                this.setCategoryBySlug();
                this.$emit('updated');
            }
        },

        computed: {
            categories() {
                return this.$store.state.categories;
            },
        },

        methods: {
            categoryChanged () {
                if (this.selectedCategory === 'null') {
                    this.$router.push({ name: this.routeStart });
                } else {
                    this.$router.push({ name: this.routeCategory, params: { category_slug: this.selectedCategory.slug} });
                }
            },

            subcategoryChanged () {
                if (this.selectedSubcategory === 'null') {
                    this.$router.push({ name: this.routeCategory, params: { category_slug: this.selectedCategory.slug} });
                } else {
                    this.$router.push({ name: this.routeSubcategory, params: { category_slug: this.selectedCategory.slug, subcategory_slug: this.selectedSubcategory.slug } });
                }
            },

            currentRoute () {
                return this.$router.history.current;
            },

            isViewingSubcategory () {
                return this.currentRoute().name === this.routeSubcategory;
            },

            setCategoryBySlug () {
                this.selectedSubcategory = 'null';

                if (this.categories.length) {
                    this.selectedCategory = this.categories.find(c => c.slug === this.currentRoute().params.category_slug);
                }

                if (this.selectedCategory !== 'null' && this.isViewingSubcategory()) {
                    this.selectedSubcategory = this.selectedCategory.childrens.find(c => c.slug === this.currentRoute().params.subcategory_slug);
                }
            },
        }
    }
</script>
